var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_2841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9999C9.86522 23.9995 7.76922 23.4295 5.92818 22.3489C4.08713 21.2682 2.56769 19.716 1.52656 17.8524C0.485432 15.9887 -0.039689 13.881 0.00535817 11.7467C0.0504054 9.61243 0.663989 7.52879 1.78283 5.71071C2.90166 3.89262 4.48525 2.40591 6.37025 1.40392C8.25525 0.401925 10.3734 -0.0790801 12.5063 0.010514C14.6392 0.100108 16.7096 0.757058 18.5039 1.91361C20.2982 3.07016 21.7516 4.68443 22.714 6.58994C22.7779 6.7076 22.8176 6.8369 22.8306 6.97018C22.8436 7.10345 22.8297 7.23798 22.7898 7.36579C22.7498 7.49359 22.6846 7.61207 22.598 7.7142C22.5113 7.81632 22.4051 7.90001 22.2855 7.96029C22.166 8.02058 22.0355 8.05624 21.9019 8.06515C21.7683 8.07407 21.6342 8.05606 21.5077 8.01219C21.3812 7.96832 21.2648 7.89949 21.1654 7.80978C21.066 7.72007 20.9856 7.61131 20.929 7.48994C19.9155 5.48316 18.2553 3.87645 16.2164 2.92915C14.1775 1.98185 11.8789 1.74923 9.69159 2.26883C7.50426 2.78844 5.55584 4.02996 4.16081 5.79299C2.76579 7.55603 2.00555 9.73772 2.00281 11.9859C2.00008 14.2341 2.755 16.4176 4.14573 18.1841C5.53646 19.9505 7.48186 21.1968 9.66792 21.7217C11.854 22.2466 14.1531 22.0196 16.1943 21.0772C18.2355 20.1349 19.8996 18.5323 20.918 16.5279C21.043 16.2999 21.2519 16.1295 21.5004 16.0529C21.7489 15.9763 22.0174 15.9996 22.2491 16.1177C22.4808 16.2358 22.6573 16.4395 22.7413 16.6856C22.8253 16.9317 22.8101 17.2008 22.699 17.4359C21.6995 19.4143 20.1696 21.0759 18.2803 22.235C16.3909 23.3942 14.2165 24.0052 12 23.9999Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_2841"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.c970868c03ed1283970ea9d2124554ad.svg";
export { ForwardRef as ReactComponent };